
/**
 * @ngdoc directive
 * @name testimonial
 *
 * @description
 * Testimonial
 */
module.directive('testimonial', function () {
    'use strict';
    return {
        restrict: 'E',
        scope: {
            content: '='
        },
        template:
                '<div class="aqua-testimonial">' +
                '  <div class="grid-main grid grid-center">' +

                '    <div class="grid-10 grid-12-s grid grid-gutter">' +

                /* picture */
                '      <div class="aqua-testimonial--figure grid-12-s"><img class="aqua-testimonial--image" aqua-src="{{content.field_image.src}}" alt="{{content.field_image.alt}}" /></div>' +

                /* content */
                '      <div class="aqua-testimonial--content">' +
                '        <h3 class="aqua-testimonial--info"><span class="aqua-testimonial--title">{{content.field_firstname}} {{content.field_lastname}},</span> {{content.field_job}}</h3>' +
                '        <blockquote class="aqua-testimonial--quote" ng-bind-html="content.field_description | trustAsHtml">' +
                '        </blockquote>' +
                '      </div>' +

                '    </div>' +

                '  </div>' +
                '</div>'
    };
});
